<mat-radio-group [formControl]="$any(formControl)" [formlyAttributes]="field" [tabIndex]="to?.tabindex||0">
    <mat-radio-button *ngFor="let option of dynOptions ; let i = index;  " [value]="(this.field.templateOptions.useCode ? option.code : option.id)">
        {{getDisplayMember(option)}}
    </mat-radio-button>
</mat-radio-group>
